import { Select } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SelectPositionStatusProps {
  onSelect: (status: string) => void;
}

function SelectPositionStatusComponent({ onSelect }: SelectPositionStatusProps) {
  const { t } = useTranslation('moniterByRecruiters');
  const [selected, setSelected] = React.useState('all');
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelected(event.target.value);
    onSelect(event.target.value);
  };

  return (
    <Select
      // placeholder={t('positionRecruiters.filter.placeholder')}
      onChange={handleSelectChange}
      size="md"
      value={selected}
      w="fit-content"
      minW="unset"
      sx={{
        fontSize: 'xs',
        borderRadius: 'md',
        fontWeight: 'bold',
      }}
      flexShrink={0}
    >
      <option value="all">{t('positionRecruiters.filter.all')}</option>
      <option value="following">{t('positionRecruiters.filter.following')}</option>
      <option value="watching">{t('positionRecruiters.filter.watching')}</option>
      <option value="none">{t('positionRecruiters.filter.none')}</option>
    </Select>
  );
}

export const SelectPositionStatus = React.memo(SelectPositionStatusComponent);
